import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import "../styles/PageBanner.css"; // Create this CSS file for styling
import homeIcon from "../assets/pagesBanner.png"; // Example home icon
import PawPrintImage from "../assets/Simplification right.png";
import pageBannerBg from "../assets/pagesBanner BG.png";
import PawPrintImageLeft from "../assets/Simplification left.png";
import { LanguageContext } from "../LanguageContext"; // Import the context

const PageBanner = () => {
  const location = useLocation();

  const { language } = useContext(LanguageContext); // Use the context

  // Function to get the current page name from the URL
  const getPageName = (path) => {
    const pages = {
      en: {
        home: "Home",
        about: "About",

        subscriptions: "Subscriptions",
        tutorial: "Tutorial",
        login: "Login",
        profile: "Profile",
        contact: "Contact Us",
        safety: "Safety tips",
        community: "Community guidelines",
        privacyPolicy: "Privacy Policy",
        termsAndConditions: "Terms and Conditions"
      },
      ar: {
        home: "الرئيسية",
        about: "اقرأ عنا",

        subscriptions: "الاشتراكات",
        tutorial: "البرنامج التعليمي",
        login: "تسجيل الدخول",
        profile: "الملف الشخصي",
        contact: "تواصل معنا",
        safety: "نصائح السلامة",
        community: "ارشادات المجتمع",
        privacyPolicy: "سياسة الخصوصية",
        termsAndConditions: "الشروط والأحكام"
      },
    };
    switch (path) {
      case "/":
        return pages[language].home;
      case "/subscriptions":
        return pages[language].subscriptions;
      case "/tutorial":
        return pages[language].tutorial;
      case "/community":
        return pages[language].community;
      case "/safety":
        return pages[language].safety;
        case "/about":
          return pages[language].about;
      case "/login":
        return pages[language].login;
      case "/profile":
        return pages[language].profile;
      case "/privacy-policy":
        return pages[language].privacyPolicy;
      case "/terms-and-conditions":
        return pages[language].termsAndConditions;
      case "/contact-us":
        return pages[language].contact;
      case "/profile":
        return pages[language].profile;
      default:
        return "";
    }
  };

  return (
    <div className={`page-banner ${language === "ar" ? "rtl" : ""}`}>
      <div className="breadcrumb">
        <img src={homeIcon} alt="Home" className="home-icon" />
        <img
          src={pageBannerBg}
          alt="pageBannerBg"
          className="page-banner-bg bottom-center"
        />
        <img
          src={PawPrintImage}
          alt="Paw Print"
          className="paw-print-pageBanner bottom-right"
        />
        <img
          src={PawPrintImageLeft}
          alt="Paw Print"
          className="paw-print-pageBanner top-left"
        />
        <div className="content-display">
          <div>
            <span>{getPageName(location.pathname)}</span>
          </div>
          <div>
            <span className="home">{getPageName("/")}</span>
            {location.pathname !== "/" && (
              <>
                <span className="separator">
                  {language === "en" ? ">" : "<"}
                </span>
                <span className="pageName">
                  {getPageName(location.pathname)}
                </span>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageBanner;
